import { getNestedValue, isObject } from './objects';

export const flatMap = fn => arr => {
    // map but remove undefined
    const newArr = [];

    if (typeof arr === 'undefined' || arr === null) {
        return newArr;
    }

    arr.forEach((item, index) => {
        const mapedItem = fn(item, index, arr);

        if (typeof mapedItem !== 'undefined' && mapedItem !== null) {
            newArr.push(mapedItem);
        }
    });

    return newArr;
};

/**
 * @function recursiveFindBy
 * @description Method to find an object into a nested structure
 * @param {String} search
 * @param {Array} options
 * @param {String} childKey
 * @returns {Object} The found object
 */
const iterator = (options = [], key = 'id', value, childKey = 'children') =>
    options.reduce((acc, curr) => {
        let child = [];

        if (curr[childKey] && curr[childKey].length > 0) {
            child = iterator(curr[childKey], key, value, childKey);
        }

        if (curr[key] === value) {
            return [curr];
        }

        return [...acc, ...child];
    }, []);

export const recursiveFindBy = (options, key, value, childKey) => {
    const find = iterator(options, key, value, childKey);

    return find && find.length ? find[0] : undefined;
};

/**
 * Converts an Array of Objects to an Object Map
 * e.g. [{id: '2ab', name: 'olx'}] to {2ab: {id: '2ab', name: 'olx'}}
 * @param {Array} arr
 * @param {string|Array} keys
 * @param {string} separator
 * @returns {Object} object with keys specified
 */
export const arrayToObject = (arr = [], keys = 'id', separator = '-') => {
    const isValid = Array.isArray(arr) && (Array.isArray(keys) || typeof keys === 'string');

    if (!isValid) {
        return {};
    }

    return arr.reduce((newObj, item, index) => {
        let key = index;

        if (isObject(item)) {
            if (Array.isArray(keys)) {
                key = keys.reduce((compositeKey, curr) => {
                    const nestedValue = getNestedValue(item, curr);
                    const isNestedValue = typeof nestedValue !== 'undefined' && nestedValue !== null;

                    if (isNestedValue) {
                        return `${compositeKey}${compositeKey ? separator : ''}${nestedValue}`;
                    }

                    return compositeKey;
                }, '');
                key = key || index; // if composite key is returned empty
            }
            else {
                key = getNestedValue(item, keys, index);
            }
        }

        newObj[key] = item;
        return newObj;
    }, {});
};

/**
 * Converts an Arrays to Array of Arrays i.e [1,2,3,4,5,6] to [[1,2,3],[4,5,6]]
 * @param {Array} arr
 * @param {number} numberRowItems
 * @returns {Array}
 */
export const convertArrayToGrid = (arr, numberRowItems) => {
    const grid = [];
    let currRowIndex = 0;

    arr.forEach((item, index) => {
        const isRow = (((index + 1) % numberRowItems) === 0 || index === 0) && index !== arr.length;

        if (isRow) {
            currRowIndex = (grid.push([])) - 1;
            grid[currRowIndex === 0 ? currRowIndex : currRowIndex - 1].push(item);
        }
        else {
            grid[currRowIndex].push(item);
        }
    });
    return grid;
};

export const convertArrayToCSVString = (arr = []) => {
    if (Array.isArray(arr)) {
        const csvString = arr.reduce((acc, curr) => {
            return acc + (curr && (typeof curr === 'string') ? `${curr.trim()}, ` : '');
        }, '');

        return csvString ? csvString.trim().slice(0, csvString.length - 2) : csvString;
    }
    return '';
};
